import { createAsyncThunk } from '@reduxjs/toolkit';
import WellService from 'business/services/WellService';

export const getImageStoreInfo = createAsyncThunk(
  'getimagestoresinfo',
  async (_, thunkApi) => {
    try {
      const wellservice = new WellService();
      return await wellservice.getImageStoresInfo();
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);
